import { withPrefix } from 'gatsby-link'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Layout from '../../components/layout'

const Lms = () => {
  return (
    <Layout>
      <div className="row">
        <div className="col">
          <h3 className="instruction__heading instruction__heading_h3">Для регистрации в СЭО МАИ</h3>
          <ol className="instruction__list">
            <li className="list__item">
              <p>Войдите на сайт <a target="_blank" rel="noreferrer" href="http://lms.mai.ru/">http://lms.mai.ru/</a>.</p>
            </li>
            <li className="list__item">
              <p>В верхнем правом углу страницы введите логин и пароль, который вы получили в деканате.</p>
              <a className="item__img" target="_blank" rel="noreferrer" href={withPrefix('/images/lms/img3.jpg')}><StaticImage src="../../../static/images/lms/img3.jpg" alt="СЭО МАИ" /></a>
            </li>
            <li className="list__item">
              <p>На открывшейся странице заполните пустые поля регистрационной формы и нажмите на кнопку «Обновить профиль», расположенную внизу страницы.</p>
              <a className="item__img" target="_blank" rel="noreferrer" href={withPrefix('/images/lms/img4.jpg')}><StaticImage src="../../../static/images/lms/img4.jpg" alt="Учетная запись пользователя" /></a>
            </li>
            <li className="list__item">
              <p>Вам на почту придет электронное письмо со ссылкой для подтверждения регистрации (проверьте спам, письмо для активации учётной записи часто попадает именно в эту папку).</p>
            </li>
            <li className="list__item">
              <p>Пройдя по ссылке, вы активируете свою учетную запись.</p>
            </li>
            <li className="list__item">
              <p>Заново зайдите на сайт <a href="http://lms.mai.ru/" target="_blank" rel="noreferrer">http://lms.mai.ru/</a>.</p>
            </li>
          </ol>
        </div>
      </div>
    </Layout>
  )
}

export default Lms
   